const NEWS_API_PATH = '/api/news';

const normalizeArticle = (article) => ({
  ...article,
  id: article.id || article.databaseId || article.originalUrl,
  title: article.title || '',
  source: article.source || 'Unknown Source',
  sourceDomain: article.sourceDomain || article.source_domain || '',
  author: article.author || '',
  publishedAt: article.publishedAt || article.published_at || article.created_at || new Date().toISOString(),
  category: article.category || 'News',
  region: article.region || 'Global',
  language: article.language || 'en',
  summary: article.summary || '',
  imageUrl: article.imageUrl || article.image_url || '',
  originalUrl: article.originalUrl || article.original_url || '',
  tags: Array.isArray(article.tags) ? article.tags : [],
  entities: Array.isArray(article.entities) ? article.entities : [],
  relevanceScore: article.relevanceScore || article.relevance_score || 0,
  sentimentScore: Number(article.sentimentScore ?? article.sentiment_score ?? 0.5),
  readTime: article.readTime || article.read_time || '1 min read',
  relatedIds: Array.isArray(article.relatedIds || article.related_ids)
    ? article.relatedIds || article.related_ids
    : [],
});

export const fetchNewsArticles = async ({ limit = 80 } = {}) => {
  try {
    const params = new URLSearchParams({ limit: String(limit) });
    const response = await fetch(`${NEWS_API_PATH}?${params.toString()}`);
    const payload = await response.json();

    if (!response.ok || payload.success === false) {
      return {
        success: false,
        error: payload.error || 'News request failed.',
        data: [],
      };
    }

    return {
      success: true,
      data: (payload.data || []).map(normalizeArticle),
    };
  } catch (error) {
    return {
      success: false,
      error: error.message || 'News request failed.',
      data: [],
    };
  }
};
